<template>
    <section :style="{ background: sectionBackgroundColor }">
      <div class="relative flex flex-wrap w-full py-10 mx-auto 2xl:px-4 md:flex-row-reverse max-w-screen-2xl lg:py-20">
        <div class="relative flex items-center w-full px-5 md:w-1/2 py-9 xl:py-24 md-max:pt-0">
          <div class="w-full space-y-3.5 lg:space-y-5 mx-auto">
            <h2
              v-if="showMainHeading"
              class="max-w-lg mx-auto text-3xl font-extrabold text-center md:text-4xl pb-7 xl:text-6xl font-WWebMedium"
              v-html="mainHeading"
              :style="{ color: headingTextColor }"
            ></h2>
            <div
              class="max-w-lg mx-auto text-lg text-center md:text-lg lg:text-xl 2xl:text-2xl lg:px-6 custom-p"
              v-html="paragraph1"
              :style="{ color: paragraphTextColor }"
            ></div>
            <div
              class="max-w-lg mx-auto text-lg text-center md:text-lg lg:text-xl 2xl:text-2xl pt-7 lg:px-6"
              v-html="paragraph2"
              :style="{ color: paragraphTextColor }"
            ></div>
          </div>
        </div>
        <div class="flex w-full md:w-1/2 md:ml-auto 2xl:pr-20">
          <div class="w-full">
            <div id="" class="h-full aspect-auto">
              <nuxt-img
                :src="imageSrc"
                :alt="imageAlt"
                loading="lazy"
                format="webp"
                :width="824"
                :height="949"
                sizes="xs:320px sm:440px md:768px lg:503px xl:587px 2xl:824px"
                class="block object-cover w-full h-full m-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    mainHeading: {
      type: String,
      default: 'A New Standard In Coffee',
    },
    showMainHeading: {
      type: Boolean,
      default: true,
    },
    paragraph1: {
      type: String,
      default:
        'Not long ago, I didn’t drink coffee. I read the research on the harmful effects of conventional coffee loaded with toxins. However, the benefits of coffee were too hard to ignore. So I created the healthiest coffee possible so my patients and I could experience all the benefits with none of the drawbacks. Now it’s yours to enjoy too!',
    },
    paragraph2: {
      type: String,
      default: '- Dr. Charles Livingston, Founder of Lifeboost Coffee',
    },
    imageSrc: {
      type: String,
      default: '/assets/images/img-13.png',
    },
    imageAlt: {
      type: String,
      default: 'A New Standard In Coffee',
    },
    sectionBackgroundColor: {
      type: String,
      default: 'white',
    },
    headingTextColor: {
      type: String,
      default: '#000000',
    },
    paragraphTextColor: {
      type: String,
      default: '#374151',
    },
  });
  
  defineBuilderComponent({
    friendlyName: 'Content With Left Image',
    inputs: [
      {
        name: 'mainHeading',
        type: 'richText',
        friendlyName: 'Main Heading',
        defaultValue: 'A New Standard In Coffee',
      },
      {
        name: 'showMainHeading',
        type: 'boolean',
        friendlyName: 'Show Main Heading',
        defaultValue: true,
      },
      {
        name: 'headingTextColor',
        type: 'color',
        friendlyName: 'Heading Text Color',
        defaultValue: '#000000',
      },
      {
        name: 'paragraph1',
        type: 'richText',
        friendlyName: 'Paragraph 1',
        defaultValue:
          'Not long ago, I didn’t drink coffee. I read the research on the harmful effects of conventional coffee loaded with toxins. However, the benefits of coffee were too hard to ignore. So I created the healthiest coffee possible so my patients and I could experience all the benefits with none of the drawbacks. Now it’s yours to enjoy too!',
      },
      {
        name: 'paragraph2',
        type: 'richText',
        friendlyName: 'Paragraph 2',
        defaultValue: '- Dr. Charles Livingston, Founder of Lifeboost Coffee',
      },
      {
        name: 'paragraphTextColor',
        type: 'color',
        friendlyName: 'Paragraph Text Color',
        defaultValue: '#374151',
      },
      {
        name: 'imageSrc',
        type: 'file',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        friendlyName: 'Image Source',
        defaultValue: '/assets/images/img-13.png',
      },
      {
        name: 'imageAlt',
        type: 'string',
        friendlyName: 'Image Alt Text',
        defaultValue: 'A New Standard In Coffee',
      },
      {
        name: 'sectionBackgroundColor',
        type: 'color',
        friendlyName: 'Section Background Color',
        defaultValue: 'white',
      },
    ],
  });
  </script>
  